import {translate} from "react-i18nify";

import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as config from "../../constants/config";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as orderStatus from "../../constants/orderStatus";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as settingsActions from "../../actions/settingsActions";
import * as getterHelper from "../../helpers/getterHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as settingsHelper from "../../helpers/settingsHelper";
import * as translationHelper from "../../helpers/translationHelper";
import * as windowService from "../windowService";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.SETTINGS_SET_VALUE:
            let requestData = getterHelper.getNextRequest(state.server.requests, response.sequence);

            if (requestData === null) {
                return [
                    {
                        type: actionTypes.UNKNOWN_ACTION
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_USER_SETTINGS,
                        params: {
                            key: requestData.key
                        }
                    },
                    method: requestData.getHandler,
                    tabId: componentTypes.NO_SKIP_TAB_ID,
                    next: requestData.callback
                }
            ];
        case handlers.SETTINGS_GET_VALUE:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let saveAction = getterHelper.getNextRequest(state.server.requests, response.sequence);

            if (saveAction === null) {
                return [
                    {
                        type: actionTypes.UNKNOWN_ACTION
                    }
                ];
            }

            return [
                {
                    type: saveAction,
                    payload: {
                        value: response.data.value
                    }
                }
            ];
        case handlers.SETTINGS_GET_BLEND_FORMULA_AND_CODE:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_BLEND_FORMULA_AND_CODE,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_COLOR_TAB_COMPATIBLE_ONLY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_COLOR_TAB_COMPATIBLE_ONLY,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.RELOAD_SEARCH_PANEL_COLOR_PALETTE
                }
            ];
        case handlers.SETTINGS_GET_COLOR_TAB_NOTE_ICONS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_COLOR_TAB_NOTE_ICONS,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.RELOAD_SEARCH_PANEL_COLOR_PALETTE
                }
            ];
        case handlers.SETTINGS_GET_COLOR_TAB_ORDER_BY:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_COLOR_TAB_ORDER_BY,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.RELOAD_SEARCH_PANEL_COLOR_PALETTE
                }
            ];
        case handlers.SETTINGS_GET_COLOR_TAB_ROW_COUNT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_COLOR_TAB_ROW_COUNT,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.RELOAD_SEARCH_PANEL_COLOR_PALETTE
                }
            ];
        case handlers.SETTINGS_GET_POSITION_AND_LOAD_BANNER_LIST:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            window.imageStore.setBannerList([]);

            if (response.data.value === null) {
                return [
                    {
                        type: actionTypes.SETTINGS_SAVE_CUSTOM_BANNER_POSITION,
                        payload: {
                            value: response.data.value
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_CUSTOM_BANNER_POSITION,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_BANNERS
                    },
                    method: handlers.GET_ALL_BANNERS,
                    tabId: 0
                }
            ];
        case handlers.SETTINGS_GET_CUSTOM_CAN_OPTION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data.value === settings.CUSTOM_UNITS && state.settings.customCanUnits.length === 0) {
                return [
                    {
                        type: actionTypes.SETTINGS_SAVE_CUSTOM_CAN_OPTION,
                        payload: {
                            value: response.data.value
                        }
                    },
                    settingsActions.setCustomCanUnits(state.global.unitList.map((unit) => unit.code))
                ];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_CUSTOM_CAN_OPTION,
                    payload: {
                        value: response.data.value
                    }
                }
            ];
        case handlers.SETTINGS_GET_FORMULA_CODE:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_FORMULA_CODE,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_FORMULA_NAME:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_FORMULA_NAME,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_INTERGAMMA_MACHINE_SORTING_ORDERS:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_MACHINE_SORTING_ORDERS,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_TO_DISPENSE_GET_ORDERS,
                        params: {
                            statusFilter: orderStatus.TO_DISPENSE_ORDER_STATUS_LIST,
                            orderBy: response.data.value,
                            offset: 0,
                            rowCount: config.MAX_ORDERS_LIMIT
                        }
                    },
                    method: handlers.TO_DISPENSE_GET_ORDERS,
                    tabId: 0
                }
            ];
        case handlers.SETTINGS_SET_BASIC_SETUP_LOCALE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        case handlers.SETTINGS_GET_LOCALE:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            translationHelper.setRedlikeLocale(state.lang.languages, response.data.value);

            let languageActions = [
                {
                    type: actionTypes.SETTINGS_SAVE_LOCALE,
                    payload: {
                        value: response.data.value
                    }
                }
            ];

            if (!state.module.gammaSoftware) {
                languageActions.push({
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.RESTART_MODAL,
                        params: {
                            message: translate("restartModal.notCompletelyTranslated"),
                            type: settings.LOCALE
                        }
                    }
                });
            }

            return languageActions;
        case handlers.SETTINGS_GET_LOCK_COMPUTER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let lockComputerActions = [
                {
                    type: actionTypes.SETTINGS_SAVE_LOCK_COMPUTER,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.RESTART_MODAL,
                        params: {
                            message: translate("restartModal.restartIsRequired"),
                            type: settings.LOCK_COMPUTER
                        }
                    }
                }
            ];

            if (response.data.value) {
                if (!state.settings.automaticClientStart) {
                    lockComputerActions.push(settingsActions.setAutomaticClientStart(true));
                }

                if (!state.settings.kiosk) {
                    windowService.switchKioskMode(true);
                    lockComputerActions.push(settingsActions.setKiosk(true));
                }
            }

            return lockComputerActions;
        case handlers.SETTINGS_GET_NAVIGATION_ITEMS:
            if (!responseHelper.isGetUserSettingFormatValid(response) || !Array.isArray(response.data.value)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_NAVIGATION_ITEMS,
                    payload: {
                        value: settingsHelper.getNavigationItemsSettingsByLicense(
                            response.data.value,
                            state.module.productPricing
                        )
                    }
                }
            ];
        case handlers.SETTINGS_GET_ORDER_SEARCH_ITEMS:
            if (!responseHelper.isGetUserSettingFormatValid(response) || !Array.isArray(response.data.value)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_ORDER_SEARCH_ITEMS,
                    payload: {
                        value: response.data.value
                    }
                }
            ];
        case handlers.SETTINGS_GET_PRICE_TYPES:
            if (!responseHelper.isGetUserSettingFormatValid(response) || !Array.isArray(response.data.value)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_PRICE_TYPES,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.MAIN_TAB_RELOAD_FORMULA_PRICE_DATA
                }
            ];
        case handlers.SETTINGS_GET_SEARCH_PANEL_BASE:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BASE,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_SEARCH_PANEL_BIPP:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_SEARCH_PANEL_BIPP,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_SEARCH_PANEL_PRODUCT:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_SEARCH_PANEL_PRODUCT,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(
                    settings.SEARCH_PANEL_ORDER,
                    actionTypes.SETTINGS_SAVE_SEARCH_PANEL_ORDER
                )
            ];
        case handlers.SETTINGS_GET_SEARCH_PANEL_QUICK_SELECT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_SEARCH_PANEL_QUICK_SELECT,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSingleSetRequest(
                    settings.INTERGAMMA_ORDER_QUICK_SELECT,
                    response.data.value,
                    handlers.SETTINGS_SET_QUICK_SELECT
                )
            ];
        case handlers.SETTINGS_GET_SPECTRO_ENABLED:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (!response.data.value) {
                let navigationItems = state.settings.navigationItems.map((navigationItem) => {
                    if (navigationItem.id === settings.NAV_ITEM_SPECTRO) {
                        return {visible: false, id: navigationItem.id};
                    }

                    return navigationItem;
                });

                return [
                    settingsActions.getSettingSetRequest(
                        settings.NAVIGATION_ITEMS,
                        navigationItems,
                        handlers.SETTINGS_GET_NAVIGATION_ITEMS
                    ),
                    {
                        type: actionTypes.SETTINGS_SAVE_SPECTRO_ENABLED,
                        payload: {
                            value: response.data.value
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_SPECTRO_ENABLED,
                    payload: {
                        value: response.data.value
                    }
                }
            ];
        case handlers.SETTINGS_GET_TABS_ENABLED:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (!response.data.value) {
                return [
                    {
                        type: actionTypes.SETTINGS_SAVE_TABS_ENABLED,
                        payload: {
                            value: response.data.value
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_TABS_ENABLED,
                    payload: {
                        value: response.data.value
                    }
                },
                settingsActions.getSettingGetRequest(settings.NUMBER_OF_TABS, actionTypes.SETTINGS_SAVE_NUMBER_OF_TABS),
                settingsActions.getSettingGetRequest(
                    settings.OVERWRITE_LAST_TAB,
                    actionTypes.SETTINGS_SAVE_OVERWRITE_LAST_TAB
                )
            ];
        case handlers.SETTINGS_GET_TINTOMETRIC_SYSTEM:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_TINTOMETRIC_SYSTEM,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_TINTOMETRIC_SYSTEM
                    },
                    method: handlers.GET_ACTIVE_TINTOMETRIC_SYSTEM,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_COLORANTS
                    },
                    method: handlers.RELOAD_ALL_COLORANTS,
                    tabId: 0
                }
            ];
        case handlers.SETTINGS_GET_UFI_CODE_BASE_VALIDATION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_UFI_CODE_BASE_VALIDATION,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.SYNC_MACHINE_CONFIGURATION
                }
            ];
        case handlers.SETTINGS_GET_UFI_CODE_LOGIC:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data.value === settings.UFI_CODE_LOGIC_DISABLED) {
                return [
                    {
                        type: actionTypes.SETTINGS_SAVE_UFI_CODE_LOGIC,
                        payload: {
                            value: response.data.value
                        }
                    },
                    settingsActions.getSettingSetRequest(
                        settings.UFI_CODE_BASE_VALIDATION,
                        settings.UFI_CODE_BASE_VALIDATION_DISABLED,
                        handlers.SETTINGS_GET_UFI_CODE_BASE_VALIDATION
                    )
                ];
            }

            return [
                {
                    type: actionTypes.SETTINGS_SAVE_UFI_CODE_LOGIC,
                    payload: {
                        value: response.data.value
                    }
                },
                {
                    type: actionTypes.SYNC_MACHINE_CONFIGURATION
                }
            ];
        case handlers.SETTINGS_GET_VISIBLE_UNITS:
            if (!responseHelper.isGetUserSettingFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let unitsRequests = [
                {
                    type: actionTypes.SETTINGS_SAVE_VISIBLE_UNITS,
                    payload: {
                        value: response.data.value
                    }
                }
            ];
            const unitToShow = settingsHelper.checkLastUsedUnitVisibility(
                state.settings.lastUsedUnit,
                response.data.value,
                state.settings.formulaUnits
            );

            if (state.settings.lastUsedUnits !== unitToShow) {
                unitsRequests.push({
                    type: actionTypes.SETTINGS_SAVE_ACTIVE_FORMULA_UNIT,
                    payload: {
                        value: unitToShow
                    }
                });
            }

            for (let tab of state.navigation.tabList) {
                if (getterHelper.hasFormulaStore(tab.type)) {
                    unitsRequests.push({
                        type: actionTypes.COLORANT_PANEL_INIT,
                        payload: {
                            tabId: tab.id,
                            type: tab.type
                        }
                    });
                }
            }

            return unitsRequests;
        case handlers.SETTINGS_SET_QUICK_SELECT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
